<template>
  <el-dialog
    :title="$t('editAttrSpec.editTitle')"
    :visible.sync="dialogVisible"
    width="70%" 
    @close="handleClose"
  >
    <el-form :model="editAttrSpecInfo" :rules="rules" ref="editForm" label-width="120px">
      <el-form-item :label="$t('editAttrSpec.attrTable')" prop="tableName">
        <el-select 
          v-model="editAttrSpecInfo.tableName" 
          :placeholder="$t('editAttrSpec.tableNamePlaceholder')"
          style="width:100%"
        >
          <el-option 
            v-for="item in tableOptions" 
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.domain')" prop="domain">
        <el-input 
          v-model="editAttrSpecInfo.domain" 
          :placeholder="$t('editAttrSpec.domainPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.specName')" prop="specName">
        <el-input 
          v-model="editAttrSpecInfo.specName" 
          :placeholder="$t('editAttrSpec.specNamePlaceholder')"
          maxlength="64"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.specCd')" prop="specCd">
        <el-input 
          v-model="editAttrSpecInfo.specCd" 
          :placeholder="$t('editAttrSpec.specCdPlaceholder')"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.description')" prop="specHoldplace">
        <el-input 
          v-model="editAttrSpecInfo.specHoldplace" 
          :placeholder="$t('editAttrSpec.descriptionPlaceholder')"
          maxlength="200"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.required')" prop="required">
        <el-select 
          v-model="editAttrSpecInfo.required" 
          :placeholder="$t('editAttrSpec.requiredPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.show')" prop="specShow">
        <el-select 
          v-model="editAttrSpecInfo.specShow" 
          :placeholder="$t('editAttrSpec.showPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.valueType')" prop="specValueType">
        <el-select 
          v-model="editAttrSpecInfo.specValueType" 
          :placeholder="$t('editAttrSpec.valueTypePlaceholder')"
          style="width:100%"
        >
          <el-option 
            v-for="item in valueTypeOptions" 
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.specType')" prop="specType">
        <el-select 
          v-model="editAttrSpecInfo.specType" 
          :placeholder="$t('editAttrSpec.specTypePlaceholder')"
          style="width:100%"
        >
          <el-option label="input" value="2233"></el-option>
          <el-option label="select" value="3344"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editAttrSpec.queryShow')" prop="listShow">
        <el-select 
          v-model="editAttrSpecInfo.listShow" 
          :placeholder="$t('editAttrSpec.queryShowPlaceholder')"
          style="width:100%"
        >
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editAttrSpec">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAttrSpec } from '@/api/dev/attrSpecApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAttrSpec',
  data() {
    return {
      dialogVisible: false,
      editAttrSpecInfo: {
        specCd: '',
        specId: '',
        tableName: '',
        specName: '',
        specHoldplace: '',
        required: '',
        specShow: '',
        specValueType: '',
        specType: '',
        listShow: '',
        domain: ''
      },
      tableOptions: [
        { value: 'building_room_attr', label: this.$t('editAttrSpec.buildingRoomAttr') },
        { value: 'building_owner_attr', label: this.$t('editAttrSpec.buildingOwnerAttr') },
        { value: 'building_community_attr', label: this.$t('editAttrSpec.buildingCommunityAttr') },
        { value: 'machine_attr', label: this.$t('editAttrSpec.machineAttr') },
        { value: 'parking_area_attr', label: this.$t('editAttrSpec.parkingAreaAttr') },
        { value: 'owner_car_attr', label: this.$t('editAttrSpec.ownerCarAttr') }
      ],
      valueTypeOptions: [
        { value: '1001', label: this.$t('editAttrSpec.string') },
        { value: '2002', label: this.$t('editAttrSpec.integer') },
        { value: '3003', label: this.$t('editAttrSpec.amount') }
      ],
      rules: {
        tableName: [
          { required: true, message: this.$t('editAttrSpec.tableNameRequired'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('editAttrSpec.domainRequired'), trigger: 'blur' }
        ],
        specName: [
          { required: true, message: this.$t('editAttrSpec.specNameRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('editAttrSpec.specNameMaxLength'), trigger: 'blur' }
        ],
        specCd: [
          { required: true, message: this.$t('editAttrSpec.specCdRequired'), trigger: 'blur' }
        ],
        specHoldplace: [
          { required: true, message: this.$t('editAttrSpec.descriptionRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editAttrSpec.descriptionMaxLength'), trigger: 'blur' }
        ],
        required: [
          { required: true, message: this.$t('editAttrSpec.requiredRequired'), trigger: 'change' }
        ],
        specShow: [
          { required: true, message: this.$t('editAttrSpec.showRequired'), trigger: 'change' }
        ],
        specValueType: [
          { required: true, message: this.$t('editAttrSpec.valueTypeRequired'), trigger: 'change' }
        ],
        specType: [
          { required: true, message: this.$t('editAttrSpec.specTypeRequired'), trigger: 'change' }
        ],
        listShow: [
          { required: true, message: this.$t('editAttrSpec.queryShowRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(attrSpec) {
      this.editAttrSpecInfo = { ...attrSpec }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      this.editAttrSpecInfo = {
        specCd: '',
        specId: '',
        tableName: '',
        specName: '',
        specHoldplace: '',
        required: '',
        specShow: '',
        specValueType: '',
        specType: '',
        listShow: '',
        domain: ''
      }
    },
    editAttrSpec() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.editAttrSpecInfo,
            shopId: getShopId()
          }
          updateAttrSpec(params).then(res => {
            this.$message.success(this.$t('editAttrSpec.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          }).catch(error => {
            console.error('更新失败:', error)
            this.$message.error(error.message || this.$t('editAttrSpec.saveFailed'))
          })
        }
      })
    }
  }
}
</script>